/**
 * Copyright © 2026 Rémi Pace.
 * This file is part of Abc-Map.
 *
 * Abc-Map is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of
 * the License, or (at your option) any later version.
 *
 * Abc-Map is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General
 * Public License along with Abc-Map. If not, see <https://www.gnu.org/licenses/>.
 */
export class ProjectConstants {
    /**
     * Maximum size of project for uploads, in bytes
     */
    static MaxSizeBytes = 5 * 1024 * 1024;
    /**
     * Version of project, used for migrations
     */
    static CurrentVersion = '1.5.0';
    /**
     * Name of main data file in project archive
     */
    static ManifestName = 'project.json';
    static FileExtension = '.abm2';
    /**
     * We must accept ".zip" in inputs too, for mobile devices
     */
    static InputFileExtensions = '.abm2,.zip';
}
//# sourceMappingURL=ProjectConstants.js.map